module.exports = __webpack_public_path__ + "static/mac-frame-65d333706510690be8ba801091226dd9.png";